// React
import { ReactElement } from 'react';
// Design System
import { Skeleton } from '@utmb/design-system/placeholder/Placeholder';
// Styles
import styles from './mobile-skeleton.module.scss';

export const MobileSkeleton = (): ReactElement => {
    return (
        <div className={styles.root}>
            {[...new Array(5)].map((v, i) => (
                <Skeleton className={styles.skeleton_item} key={i} height="30" width="12%" />
            ))}
        </div>
    );
};
